// General
// ----------------------------------------
export const adminMail = '1159-timss@dist.toyota-tsusho.com';

export const ROLE = {
  USER: 'user',
  POWERUSER: 'poweruser',
  ADMIN: 'admin',
  MAINTENANCE_ADMIN: 'maintenanceadmin',
} as const;

export const ROLE_OPTIONS = {
  USER: {
    label: ROLE.USER,
    value: [ROLE.USER],
  },
  POWERUSER: {
    label: ROLE.POWERUSER,
    value: [ROLE.POWERUSER],
  },
  ADMIN: {
    label: ROLE.ADMIN,
    value: [ROLE.ADMIN],
  },
  MAINTENANCE_ADMIN: {
    label: ROLE.MAINTENANCE_ADMIN,
    value: [ROLE.MAINTENANCE_ADMIN],
  },
};

export const LANGUAGE = {
  JA: 'ja',
  EN: 'en',
} as const;

export const GENERAL_ERROR_MESSAGE = 'Error Occurred';

export const DATE_TYPE = {
  START_DATE: 'startDate',
  END_DATE: 'endDate',
} as const;

export const EDIT_ACTION = {
  CREATE: 'CREATE',
  VIEW: 'VIEW',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
} as const;

export const STEEL_MAKER = {
  NIPPONSTEEL: 'NIPPONSTEEL',
  AICHISTEEL: 'AICHISTEEL',
  KOBESTEEL: 'KOBESTEEL',
  JFESTEEL: 'JFESTEEL',
} as const;
export const STEEL_MAKER_NAME = {
  NIPPONSTEEL: {
    JA: '日本製鉄',
    EN: 'NIPPON_STEEL',
  },
  AICHISTEEL: {
    JA: '愛知製鋼',
    EN: 'AICHI_STEEL',
  },
  KOBESTEEL: {
    JA: '神戸製鋼',
    EN: 'KOBE_STEEL',
  },
  JFESTEEL: {
    JA: 'JFEスチール',
    EN: 'JFE_STEEL',
  },

} as const;
export const BUSINESS_TYPE = {
  DOMESTIC: 'DOMESTIC',
  EXPORT: 'EXPORT',
} as const;
export const STEEL_CATEGORY = {
  BAR: 'BAR',
  PIPE: 'PIPE',
  PLATE: 'PLATE',
} as const;
export const STEEL_TYPE = {
  BAR: 'BAR',
  WIRE_ROD: 'WIRE_ROD',
  PIPE: 'PIPE',
  STEEL_PLATE: 'STEEL_PLATE',
  STEEL_SHEET: 'STEEL_SHEET',
  HOT_ROLLED_STEEL_SHEET: 'HOT_ROLLED_STEEL_SHEET',
  COLD_ROLLED_STEEL_SHEET: 'COLD_ROLLED_STEEL_SHEET',
  ELECTROGALVANIZED_STEEL_SHEET: 'ELECTROGALVANIZED_STEEL_SHEET',
  GALVANNEALED_STEEL_SHEET: 'GALVANNEALED_STEEL_SHEET',
  GALVANIZED_STEEL_SHEET: 'GALVANIZED_STEEL_SHEET',
  ZINC_COATED_STEEL_SHEET: 'ZINC_COATED_STEEL_SHEET',
  ALUMINUM_COSTED_STEEL_SHEET: 'ALUMINUM_COSTED_STEEL_SHEET',
  SUPER_DYMA: 'SUPER_DYMA',
  VIBLESS: 'VIBLESS',
} as const;

 export const SELECTABLE_STEEL_TYPE_LABELS = {
  AICHISTEEL: {
    EN: ['BAR'],
    JA: ['棒鋼'],
  },
  JFESTEEL: {
    EN: ['BAR', 'WIRE_ROD', 'STEEL_SHEET'],
    JA: ['棒鋼', '線材','薄板'],
  },
  KOBESTEEL: {
    EN: ['BAR', 'WIRE_ROD', 'STEEL_SHEET'],
    JA: ['棒鋼', '線材','薄板'],
  },
};

export const STEEL_MILLS_NSC = {
  MURORAN: { index: 10, code: 'MURORAN', nameJapanese: '室蘭', nameEnglish: 'MURORAN' },
  KAMAISHI: { index: 20, code: 'KAMAISHI', nameJapanese: '釜石', nameEnglish: 'KAMAISHI' },
  KASHIMA: { index: 30, code: 'KASHIMA', nameJapanese: '鹿島', nameEnglish: 'KASHIMA' },
  KIMITSU: { index: 40, code: 'KIMITSU', nameJapanese: '君津', nameEnglish: 'KIMITSU' },
  NAGOYA: { index: 50, code: 'NAGOYA', nameJapanese: '名古屋', nameEnglish: 'NAGOYA' },
  WAKAYAMA: { index: 70, code: 'WAKAYAMA', nameJapanese: '和歌山', nameEnglish: 'WAKAYAMA' },
  SAKAI: { index: 75, code: 'SAKAI', nameJapanese: '堺', nameEnglish: 'SAKAI' },
  // 半角カッコは検索時にうまくいかないため、ダブルクォーテーションで囲む
  SAKAI_HANSHIN: { index: 77, code: 'SAKAI(HANSHIN)', nameJapanese: '"堺(阪神)"', nameEnglish: '"SAKAI(HANSHIN)"' },
  HIROHATA: { index: 100, code: 'HIROHATA', nameJapanese: '広畑', nameEnglish: 'HIROHATA' },
  YAWATA: { index: 110, code: 'YAWATA', nameJapanese: '八幡', nameEnglish: 'YAWATA' },
  OITA: { index: 120, code: 'OITA', nameJapanese: '大分', nameEnglish: 'OITA' },
  // 半角カッコは検索時にうまくいかないため、ダブルクォーテーションで囲む
  OITA_HIKARI: { index: 130, code: 'OITA(HIKARI)', nameJapanese: '"大分(光鋼管)"', nameEnglish: '"OITA(HIKARI)"' },
} as const;
export const STEEL_MILLS_AICHI = {
  CHITA: { index: 60, code: 'CHITA', nameJapanese: '知多', nameEnglish: 'CHITA' },
} as const;
export const STEEL_MILLS_KOBE = {
  KAKOGAWA: { index: 80, code: 'KAKOGAWA', nameJapanese: '加古川', nameEnglish: 'KAKOGAWA' },
  KOBE: { index: 90, code: 'KOBE', nameJapanese: '神戸', nameEnglish: 'KOBE' },
} as const;

export const STEEL_MILLS_JFE = {
  SENDAI: { index: 15, code: 'SENDAI', nameJapanese: '仙台', nameEnglish: 'SENDAI' },
  CHIBA: { index: 33, code: 'CHIBA', nameJapanese: '千葉', nameEnglish: 'CHIBA' },
  KEIHIN: { index: 36, code: 'KEIHIN', nameJapanese: '京浜', nameEnglish: 'KEIHIN' },
  NISHINOMIYA: { index: 85, code: 'NISHINOMIYA', nameJapanese: '西宮', nameEnglish: 'NISHINOMIYA' },
  KURASHIKI: { index: 103, code: 'KURASHIKI', nameJapanese: '倉敷', nameEnglish: 'KURASHIKI' },
  FUKUYAMA: { index: 106, code: 'FUKUYAMA', nameJapanese: '福山', nameEnglish: 'FUKUYAMA' },
} as const;


// Ag-Grid
// ----------------------------------------

export const TOOLTIP_SHOW_DELAY = 0;

// 検索画面のダウンロード数制限
export const MAX_PDF_DOWNLOAD = 200;

// 検索画面のオプションフィールド名
export const CUSTOMER_FIELD_NAMES = {
  CUSTOMER1: 'feInputCustomer1',
  CUSTOMER2: 'feInputCustomer2',
  CUSTOMER3: 'feInputCustomer3',
} as const;
export const SEARCH_FIELD_NAMES = {
  MAKER_NAME_JA: 'feInputMakerNameJa',
  MAKER_NAME_EN: 'feInputMakerNameEn',
  MILL_JA: 'feInputMillJa',
  MILL_EN: 'feInputMillEn',
  MATERIAL_TYPE_JA: 'feInputMaterialTypeJa',
  MATERIAL_TYPE_EN: 'feInputMaterialTypeEn',
  TRADE_ORG: 'feInputTradeOrg',
  START_DATE: 'feInputCertIssueStartDate',
  END_DATE: 'feInputCertIssueEndDate',
  ORDER_NO: 'feInputOrderNumber',
  CONTRACT_NO: 'feInputContractNumber',
  STANDARD: 'feInputStandard',
  MATERIAL_SIZE_D_START: 'feInputMaterialSizeDStart',
  MATERIAL_SIZE_D_END: 'feInputMaterialSizeDEnd',
  MATERIAL_SIZE_T_START: 'feInputMaterialSizeTStart',
  MATERIAL_SIZE_T_END: 'feInputMaterialSizeTEnd',
  MATERIAL_SIZE_L_START: 'feInputMaterialSizeLStart',
  MATERIAL_SIZE_L_END: 'feInputMaterialSizeLEnd',
  MELT_NO: 'feInputMeltNumber',
  PACKAGE_ID: 'feInputPackageId',
  DESTINATION: 'feInputDestination',
  PLACE_CODE: 'feInputPlaceCode',
  CERT_NO: 'feInputCertNumber',
  BUNDLE_NO: 'feInputBundleNumber',
  ...CUSTOMER_FIELD_NAMES,
} as const;

// 検索画面でサーバに送るクエリの名前
export const SEARCH_QUERY_NAMES = {
  feInputLanguage: 'Language',
  feInputCreateDate: 'createDate',
  feInputMakerNameJa: 'メーカー名',
  feInputMakerNameEn: 'メーカー名_EN',
  feInputMillJa: 'ミル情報',
  feInputMillEn: 'ミル情報_EN',
  feInputMaterialTypeJa: '品種',
  feInputMaterialTypeEn: '品種_EN',
  feInputTradeOrg: '商社店部課',
  feInputCertIssueDate: '証明書発行年月日',
  feInputOrderNumber: '契約番号_商社',
  feInputContractNumber: '契約番号',
  feInputStandard: '規格',
  feInputMaterialSizeD: '寸法_径',
  feInputMaterialSizeT: '寸法_厚さ',
  feInputMaterialSizeL: '寸法_長さ',
  feInputMeltNumber: '溶解番号',
  feInputPackageId: '検査番号',
  feInputDestination: '日本製鉄_輸出.仕向国',
  feInputCustomer1: '需要家コード1',
  feInputCustomer2: '需要家コード2',
  feInputCustomer3: '需要家コード3',
  feInputPlaceCode: '受渡場所コード',
  feInputCertNumber: '証明書番号',
  feInputBundleNumber: '愛知製鋼_輸出.束No',
} as const;

export const DATE_COMPARISON_OPTIONS = [
  { value: 'lte', label: '以前 (>=)' },
  { value: 'gte', label: '以後 (<=)' },
  { value: 'eq', label: 'と等しい (=)' },
];

// Condition
// ----------------------------------------

export const MANAGE_CONDITION_TYPES = {
  ORDINARY: 'ORDINARY',
  CUSTOMIZE: 'CUSTOMIZE',
} as const;

export const CONDITION_STATUS = {
  APPROVED: 'APPROVED',
  EDITING: 'EDITING',
  REQUEST: 'REQUEST',
} as const;
export const CONDITION_STATUS_JA = {
  APPROVED: '承認済み',
  EDITING: '編集中',
  REQUEST: '承認依頼中',
} as const;

export const CONDITION_VIEW_MODES = {
  APPROVED: CONDITION_STATUS.APPROVED,
  EDITING: CONDITION_STATUS.EDITING,
} as const;

// Approve Condition
// ----------------------------------------

export const APPROVAL_VIEWS = {
  CONFIRM: 'CONFIRM',
  HISTORY: 'HISTORY',
} as const;
export const APPROVAL_VIEWS_JA = {
  CONFIRM: '未承認一覧',
  HISTORY: '承認状況一覧',
} as const;

export const APPROVAL_VIEW_MODES = {
  CONFIRM: APPROVAL_VIEWS.CONFIRM,
  HISTORY: APPROVAL_VIEWS.HISTORY,
} as const;

// Inventory
// ----------------------------------------

export const JOB_STATUS = {
  '0': 'WAITING',
  '1': 'RUNNING',
  '2': 'STOPPED',
  '3': 'COMPLETE',
} as const;
export const JOB_STATUS_JA = {
  '0': '実行待ち',
  '1': '実行中',
  '2': '停止済',
  '3': '完了',
} as const;

export const RESPONSE_STATUS = {
  '0': 'UNANSWERED',
  '1': 'CONTINUATION',
  '2': 'DELETE',
} as const;
export const RESPONSE_STATUS_JA = {
  '0': '未回答',
  '1': '継続',
  '2': '削除',
} as const;

export const USER_STATUS = {
  '0': 'NO CONTACT',
  '1': 'CONTACTED ONCE',
  '2': 'CONTACTED TWICE',
  '3': 'DELETED',
} as const;
export const USER_STATUS_JA = {
  '0': '未連絡',
  '1': '初回連絡済',
  '2': '2回連絡済',
  '3': '削除済',
} as const;
